import React from 'react';

export function FormGroup({ label, children }) {
  return (
    <div className="flex flex-col gap-[3px] mb-[10px]">
      <label className="text-[11px] text-grey">{label}</label>
      {children}
    </div>
  );
}
